<script>
  import { navigate } from 'svelte-routing';
  import { tenantLogado } from '../../Classes/Stores.js';
  import Constantes from '../../Classes/Constantes.js';

  export let abaAtiva;
  export let horariosCount = 0;
  export let agendamentosCount = 0;

  let menuAberto = false;

  $: tenant = $tenantLogado;
  $: contaBloqueada = tenant ? (tenant.ativo === 0 || tenant.dias_restantes <= 0) : false;
  $: labelMenu = getLabel(abaAtiva);

  function getLabel(aba) {
    const labels = {
      agendamentos: 'Agendamentos',
      disponiveis: 'Horários disponíveis',
      horarios: 'Criar Horários',
      locais: 'Meus Locais/minhas agendas',
      config_campos: 'Campos do Formulário',
      personalizar: 'Identidade Visual',
      creditos: 'Créditos e Licença',
      indicacao: 'Ganhe créditos',
      perfil: 'Meu Perfil',
      configuracoes: 'Configurações',
      tutorial: 'Tutorial'
    };

    return labels[aba] || 'Menu';
  }

  function selecionarAba(novaAba) {
    menuAberto = false;

    if (contaBloqueada && novaAba === 'agendamentos') {
      alert('Realize o pagamento da sua assinatura para acessar o painel de agendamentos.');
      abaAtiva = 'creditos';
      return;
    }

    abaAtiva = novaAba;
  }

  function sair() {
    localStorage.removeItem('usuarioLogado');
    tenantLogado.set(null);
    navigate(Constantes.tela_login);
  }
</script>

<aside class="sidebar">
  <div class="sidebar-mobile-top">
    <div class="sidebar-header">
      <div class="logo-box"><i class="fas fa-calendar-check"></i></div>
      <div class="user-info">
        <span class="user-name">{tenant?.nome || 'Admin'}</span>
        <span class="user-role">Profissional</span>
      </div>
    </div>

    <button
      class="mobile-menu-toggle"
      type="button"
      aria-expanded={menuAberto}
      on:click={() => (menuAberto = !menuAberto)}
    >
      <span>{labelMenu}</span>
      <i class="fas fa-chevron-down"></i>
    </button>
  </div>

  {#if menuAberto}
    <div class="mobile-menu-backdrop" on:click={() => (menuAberto = false)}></div>
  {/if}

  <div class="sidebar-nav-wrap {menuAberto ? 'mobile-open' : ''}">
    <nav class="sidebar-menu">
      <button
        class:active={abaAtiva === 'agendamentos'}
        class:bloqueado={contaBloqueada}
        disabled={contaBloqueada}
        on:click={() => selecionarAba('agendamentos')}
      >
        <i class="fas fa-users"></i> Agendamentos <span class="badge highlight">{agendamentosCount}</span>
      </button>

      <button class:active={abaAtiva === 'disponiveis'} on:click={() => selecionarAba('disponiveis')}>
        <i class="far fa-clock"></i> Horários disponíveis <span class="badge">{horariosCount}</span>
      </button>

      <button class:active={abaAtiva === 'horarios'} on:click={() => selecionarAba('horarios')}>
        <i class="fas fa-plus-circle"></i> Criar Horários
      </button>

      <button class:active={abaAtiva === 'locais'} on:click={() => selecionarAba('locais')}>
        <i class="fas fa-map-marker-alt"></i> Meus Locais/minhas agendas
      </button>

      <button class="nav-item" class:active={abaAtiva === 'config_campos'} on:click={() => selecionarAba('config_campos')}>
        <i class="fas fa-tasks"></i> Campos do Formulário
      </button>

      <button class:active={abaAtiva === 'personalizar'} on:click={() => selecionarAba('personalizar')}>
        <i class="fas fa-paint-brush"></i> Identidade Visual
      </button>

      <button
        class="sidebar-btn"
        class:active={abaAtiva === 'creditos'}
        class:destaque-pagamento={contaBloqueada}
        on:click={() => selecionarAba('creditos')}
      >
        <div class="btn-content">
          <i class="fas fa-coins icon-menu"></i>
          <span>Créditos e Licença</span>
        </div>

        {#if tenant && (tenant.dias_restantes <= 5 || tenant.status_ultimo_pagamento === 'pending')}
          <span class="badge-alerta-sidebar">!</span>
        {/if}
      </button>

      <button class:active={abaAtiva === 'indicacao'} on:click={() => selecionarAba('indicacao')}>
        <i class="fas fa-hand-holding-heart"></i> Ganhe créditos
      </button>

      <button class:active={abaAtiva === 'perfil'} on:click={() => selecionarAba('perfil')}>
        <i class="fas fa-user-circle"></i> Meu Perfil
      </button>

      <button class:active={abaAtiva === 'configuracoes'} on:click={() => selecionarAba('configuracoes')}>
        <i class="fas fa-cog"></i> Configurações
      </button>

      <button class:active={abaAtiva === 'tutorial'} on:click={() => selecionarAba('tutorial')}>
        <i class="fas fa-graduation-cap"></i> Tutorial
      </button>

      <button on:click={() => window.open('https://wa.me/558199628025?text=Olá, preciso de ajuda com o sistema!', '_blank')}>
        <i class="fab fa-whatsapp"></i> Suporte WhatsApp
      </button>
    </nav>

    <div class="sidebar-footer">
      <button class="logout-btn" on:click={sair}><i class="fas fa-sign-out-alt"></i> Sair</button>
    </div>
  </div>
</aside>

<style>
  .sidebar {
    width: 260px;
    background: var(--primary);
    color: white;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    box-shadow: 4px 0 15px rgba(0, 0, 0, 0.1);
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.35) transparent;
  }

  .sidebar::-webkit-scrollbar {
    width: 8px;
  }

  .sidebar::-webkit-scrollbar-track {
    background: transparent;
  }

  .sidebar::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.35);
    border-radius: 999px;
  }

  .sidebar-header {
    padding: 30px 20px;
    display: flex;
    align-items: center;
    gap: 15px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .logo-box {
    width: 40px;
    height: 40px;
    background: var(--accent);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
  }

  .user-name {
    display: block;
    font-weight: 700;
    font-size: 0.95rem;
  }

  .user-role {
    font-size: 0.75rem;
    opacity: 0.7;
  }

  .sidebar-mobile-top {
    display: none;
  }

  .mobile-menu-toggle {
    display: none;
  }

  .sidebar-nav-wrap {
    display: flex;
    flex: 1;
    flex-direction: column;
  }

  .sidebar-menu {
    flex: 1;
    padding: 20px 10px;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .sidebar-menu button {
    background: transparent;
    border: none;
    color: var(--secondary);
    padding: 12px 15px;
    text-align: left;
    border-radius: 8px;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 12px;
    transition: 0.2s;
  }

  .sidebar-menu button:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.05);
    color: white;
  }

  .sidebar-menu button.active:not(.bloqueado) {
    background: rgba(255, 255, 255, 0.15);
    color: white;
    border-left: 4px solid var(--accent);
  }

  .sidebar-menu button.bloqueado {
    opacity: 0.4;
    cursor: not-allowed;
    color: rgba(255, 255, 255, 0.4);
    background-color: transparent !important;
  }

  .sidebar-menu button.destaque-pagamento {
    color: var(--accent);
    font-weight: 800;
    background: rgba(255, 255, 255, 0.1);
    border-left: 4px solid #e53e3e;
  }

  .sidebar-btn .btn-content {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .badge {
    margin-left: auto;
    background: rgba(0, 0, 0, 0.2);
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 0.75rem;
  }

  .badge.highlight {
    background: var(--accent);
    color: white;
  }

  .sidebar-footer {
    padding: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }

  .logout-btn {
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: white;
    width: 100%;
    padding: 10px;
    border-radius: 8px;
    cursor: pointer;
  }

  .logout-btn:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  @media (max-width: 900px) {
    .sidebar {
      width: 100%;
      height: auto;
      box-shadow: none;
      position: sticky;
      top: 0;
      z-index: 20;
    }

    .sidebar-mobile-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      padding: 12px 16px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    .sidebar-header {
      padding: 0;
      border-bottom: 0;
      flex: 1;
    }

    .mobile-menu-toggle {
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      min-width: 180px;
      background: rgba(255, 255, 255, 0.12);
      color: white;
      border: 1px solid rgba(255, 255, 255, 0.15);
      border-radius: 999px;
      padding: 10px 14px;
      font-size: 0.9rem;
      font-weight: 700;
      cursor: pointer;
    }

    .mobile-menu-toggle span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .sidebar-nav-wrap {
      display: none;
      position: fixed;
      inset: 72px 16px auto 16px;
      max-height: calc(100vh - 90px);
      overflow-y: auto;
      background: var(--primary);
      border-radius: 16px;
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);
      border: 1px solid rgba(255, 255, 255, 0.12);
      z-index: 30;
    }

    .sidebar-nav-wrap.mobile-open {
      display: flex;
    }

    .mobile-menu-backdrop {
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.3);
      z-index: 25;
    }

    .sidebar-menu {
      padding: 12px;
      gap: 6px;
    }

    .sidebar-menu button {
      padding: 10px 12px;
      font-size: 0.85rem;
      white-space: normal;
    }

    .sidebar-footer {
      padding: 12px;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
    }
  }

  @media (max-width: 640px) {
    .sidebar-mobile-top {
      padding: 10px 14px;
    }

    .user-name {
      font-size: 0.9rem;
    }

    .mobile-menu-toggle {
      min-width: 160px;
      font-size: 0.85rem;
      padding: 9px 12px;
    }

    .sidebar-nav-wrap {
      inset: 66px 12px auto 12px;
    }

    .sidebar-menu {
      padding: 10px;
      gap: 6px;
    }

    .sidebar-menu button {
      padding: 10px 12px;
      font-size: 0.85rem;
    }

    .logout-btn {
      padding: 10px 12px;
    }
  }

  .badge-alerta-sidebar {
    background-color: #e53e3e;
    color: white;
    font-size: 0.75rem;
    font-weight: bold;
    padding: 2px 7px;
    border-radius: 50%;
    margin-left: auto;
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(229, 62, 62, 0.7);
    }
    70% {
      transform: scale(1);
      box-shadow: 0 0 0 6px rgba(229, 62, 62, 0);
    }
    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(229, 62, 62, 0);
    }
  }

  .btn-suporte {
    display: flex;
    align-items: center;
    gap: 10px;
    background: #25d366;
    color: white;
    padding: 12px;
    border-radius: 8px;
    text-decoration: none;
    font-weight: 600;
    font-size: 0.9rem;
    transition: 0.3s;
  }

  .btn-suporte:hover {
    background: #128c7e;
  }
</style>